import { render, staticRenderFns } from "./UpdateAvatar.vue?vue&type=template&id=582d7f8e&scoped=true&"
import script from "./UpdateAvatar.vue?vue&type=script&lang=js&"
export * from "./UpdateAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAvatar.vue?vue&type=style&index=0&id=582d7f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d7f8e",
  null
  
)

export default component.exports